import { createContext } from "preact";
import { useContext } from "preact/hooks";

export interface AuthState {
  status: "loading" | "anon" | "authed";
  email?: string;
}

const AuthContext = createContext<{
  auth: AuthState;
  logout: () => void;
} | null>(null);

type NavigateOptions = {
  replace?: boolean;
};

const NavigationContext = createContext<
  (to: string, options?: NavigateOptions) => void
>(() => {
  throw new Error("useNavigate called outside NavigationProvider");
});

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}

export function useNavigate() {
  return useContext(NavigationContext);
}

export function AuthProvider({
  auth,
  logout,
  children,
}: {
  auth: AuthState;
  logout: () => void;
  children: any;
}) {
  return (
    <AuthContext.Provider value={{ auth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function NavigationProvider({
  navigate,
  children,
}: {
  navigate: (to: string, options?: NavigateOptions) => void;
  children: any;
}) {
  return (
    <NavigationContext.Provider value={navigate}>
      {children}
    </NavigationContext.Provider>
  );
}
